// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vl-8";
export var editMode = "_vl-3";
export var headerRow = "_vl-a";
export var headerTitle = "_vl-b";
export var product = "_vl-1";
export var productDetails = "_vl-5";
export var productDivider = "_vl-7";
export var productImage = "_vl-2";
export var productInfo = "_vl-4";
export var productTitle = "_vl-6";
export var strikethrough = "_vl-9";
export var upsellProductsCard = "_vl-0";